import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 4v6a6 6 0 0 0 12 0V4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4", x2: "20", y1: "20", y2: "20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Underline";
const Underline = memo(themed(Icon));
export {
  Underline
};
//# sourceMappingURL=underline.js.map
